import RequestsList from './model/requests.model';
import MemberRequestForm from './model/form.model';

class RequestsController {
  constructor(MemberRequestApiService, AcrewardsStore, $timeout, $translate) {
    'ngInject';
    
    this.$translate = $translate;
    this.$timeout = $timeout;
    this.MemberRequestApiService = MemberRequestApiService;
    this.AcrewardsStore = AcrewardsStore;
  }

  $onInit() {
    this.model = new RequestsList();
    this.form = new MemberRequestForm();
    this.$timeout(() => {
      $('#datatable-responsive').footable();
    });

    this.MemberRequestApiService.getMemberRequests().then((resp) => {
      this.renderTable(resp);
    })

    this.AcrewardsStore.getDashboardDetails().then((details) => {
      this.model.currency = details.others.currency;
      this.model.verifiedAt = details.others.verifiedAt;
      this.model.accountStatus = details.others.verifiedAt ? this.$translate.instant('Verified') : this.$translate.instant('Not Verified');
    });
  }

  tableEventHandler() {
    this.$timeout(() => {
      $( window ).resize(function() {
        $('#requests-table').footable();
        $('#requests-table').trigger('footable_redraw');
      });
      $(window).trigger('resize');

      window.dispatchEvent(new Event('resize'));

      var evt = window.document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    }, 0);
  }

  renderTable(data) {
    $('.table-loading').hide();
    this.model.pageParams.limit = data.limit;
    this.model.pageParams.page = data.page
    this.model.requests = data.items;
    this.model.recordsTotal = data.total;
    this.model.recordsFiltered = data.total_filtered;

    this.$timeout(() => {
        $('.turnover-table').fadeIn(300);
    }, 300);
    this.tableEventHandler();
}

  onFiltered(data, total, filter) {
    this.model.total = data.total;
    this.model.totalFiltered = data.total_filtered;
    this.model.requests = data.requests

    this.form.requestFrom = filter.from;
    this.form.requestTo = filter.to;
    this.form.requestsType = filter.types;
    this.form.requestsStatus = filter.status;

    this.renderTable(data);
  }

  onPaginate(page, offset, limit, from, to, types, status) {
    this.model.pageParams.page = page;
    this.model.pageParams.offset = offset;
    this.form.limit = limit;
    this.form.page = page;
    this.form.requestFrom = from;
    this.form.requestTo = to;
    this.form.requestsType = types;
    this.form.requestsStatus = status;

    this.MemberRequestApiService.getMemberRequests(this.form.toPayload()).then((resp) => {
      this.renderTable(resp);
    })
  }

  onCustomerProductsLoaded(customerProductsList) {
    this.model.availableBalance = customerProductsList.balance;
  }

  removeUnderscore(str) {
    return str.replace(/_/g, " ");
  }
}

export default RequestsController;


// WEBPACK FOOTER //
// ./client/app/pages/requests/requests.controller.js